import * as React from 'react';
import { observer } from 'mobx-react';
import * as classNames from 'classnames';
import { VideoTile } from './VideoTile';
import { AsyncLoader } from '../../Common/AsyncLoader';
import { Video } from '../../../models';
import './style.css';

export interface VideoMiniListProps {
  className?: string;
  emptyMessage?: string;
  error: boolean;
  getVideoUrl: (video: Video) => string;
  loading: boolean;
  pageUrl: string;
  title: string;
  videos: Array<Video>;
}

export interface VideoMiniListState {
  /* empty*/
}

@observer
export class VideoMiniList extends React.Component<
  VideoMiniListProps,
  VideoMiniListState
> {
  render() {
    const {
      className,
      emptyMessage,
      error,
      getVideoUrl,
      loading,
      pageUrl,
      title,
      videos
    } = this.props;

    const combinedClassName = classNames('video-mini-list', className);

    return (
      <section className={combinedClassName}>
        <h2 className="video-mini-list-title">{title}</h2>
        <AsyncLoader
          className="video-mini-list-loader video-mini-list-videos"
          error={error}
          errorMessage={`Sorry, an error occurred while trying to load the ${title.toLowerCase()}.`}
          loading={loading}
          pageUrl={pageUrl}
        >
          <div className="video-mini-list-videos">
            {videos.length ? (
              videos.map(video => (
                <VideoTile
                  getVideoUrl={getVideoUrl}
                  key={video.id}
                  video={video}
                />
              ))
            ) : (
              <p className="video-mini-list-empty-message">
                {emptyMessage
                  ? emptyMessage
                  : `No ${title.toLowerCase()} found.`}
              </p>
            )}
          </div>
        </AsyncLoader>
      </section>
    );
  }
}

export default VideoMiniList;



// WEBPACK FOOTER //
// ./src/app/components/Video/VideoMiniList/index.tsx